import { render, staticRenderFns } from "./RegistroDeSaques.vue?vue&type=template&id=81fd467a&scoped=true"
import script from "./RegistroDeSaques.vue?vue&type=script&lang=js"
export * from "./RegistroDeSaques.vue?vue&type=script&lang=js"
import style0 from "./RegistroDeSaques.vue?vue&type=style&index=0&id=81fd467a&prod&lang=css"
import style1 from "./RegistroDeSaques.vue?vue&type=style&index=1&id=81fd467a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fd467a",
  null
  
)

export default component.exports